//To be used on textareas. Can use Shift-key or Ctrl-key or Option-key on Mac, whichever the situation permits.

(function (app) {

    app.directive("blurOnShiftEnter",
        function () {
            return function (scope, element) {
                element.bind("keypress",
                    function (event) {
                        if (event.which === 13 && (event.shiftKey || event.ctrlKey || event.metaKey)) {
                            event.preventDefault();
                            element.blur();
                        }
                    });
            };
        });

})(window.app); //jshint ignore:line